import {IMatch} from "data/types/entities";
import {MatchStatusEnum} from "data/enums";

export abstract class MatchUtils {
	static isPlaying(match: IMatch) {
		return [
			MatchStatusEnum.FIRST_QUARTER,
			MatchStatusEnum.SECOND_QUARTER,
			MatchStatusEnum.THIRD_QUARTER,
			MatchStatusEnum.FOURTH_QUARTER,
			MatchStatusEnum.OVERTIME,
			MatchStatusEnum.HALF_TIME,
		].includes(match.status);
	}

	static isComplete(match: IMatch) {
		return [MatchStatusEnum.COMPLETE].includes(match.status);
	}

	static isScheduled(match: IMatch) {
		return [MatchStatusEnum.SCHEDULED].includes(match.status);
	}
}
